__turbopack_context__.v({
  "icon": "feature-block-module-scss-module__790Mwa__icon",
  "service__description": "feature-block-module-scss-module__790Mwa__service__description",
  "service__title": "feature-block-module-scss-module__790Mwa__service__title",
});
